

export default function FinanceForm({ formData, handleInputChange, errors }) {
    const handleChange = (e) => {
        handleInputChange(e); // Call the parent function which already handles validation
    };

    return (
        <div>
            <h4>Financial Information</h4>

            {/* Existing Debts or Loans */}
            <div className="single-box pt_15">
                <div className="inner-title">
                    <p>Do you have any existing debts or loans?</p>
                </div>
                <div className="appointment-checkbox">
                    <label>
                        <input
                            type="radio"
                            name="existingDebts"
                            id="radio9"
                            value="yes"
                            checked={formData.existingDebts === "yes"}
                            onChange={handleChange}
                            required
                        />
                        Yes
                    </label>
                    <label>
                    
                        <input
                            type="radio"
                            name="existingDebts"
                            id="radio10"
                            value="no"
                            checked={formData.existingDebts === "no"}
                            onChange={handleChange}
                            required
                        />
                        No
                    </label>   
                    
                </div>
                {errors.existingDebts && <span className="error-message">{errors.existingDebts}</span>}
            </div>

            {/* Outstanding Balances */}
            <div className="single-box ">
                <div className="inner-title">
                    <p>Please list any outstanding balances:</p>
                </div>
                <input
                    type="text"
                    name="Outstanding_Balance"
                    value={formData.Outstanding_Balance || ""}
                    maxLength={20}
                    onChange={handleChange}
                    required
                />
                {errors.Outstanding_Balance && <span className="error-message">{errors.Outstanding_Balance}</span>}
            </div>

            {/* Bankruptcy Status */}
            <div className="single-box">
                <div className="inner-title">
                    <p>Are you currently in bankruptcy or have you been in bankruptcy in the past?</p>
                </div>
                <div className="appointment-checkbox">
                    <label>
                        <input
                            type="radio"
                            name="appointment12"
                            id="radio11"
                            value="yes"
                            checked={formData.appointment12 === "yes"}
                            onChange={handleChange}
                            required
                        />
                    Yes
                </label>
                        
                    
                    <label>
                        <input
                            type="radio"
                            name="appointment12"
                            id="radio12"
                            value="no"
                            checked={formData.appointment12 === "no"}
                            onChange={handleChange}
                            required
                        />
                        No
                        </label>
                    
                </div>
                {errors.appointment12 && <span className="error-message">{errors.appointment12}</span>}
            </div>
        </div>

    );
}
